document.addEventListener(
  "click",
  (e) => {
    const root = document.getElementById("mobile-menu");
    if (!root) return;

    const openBtn = e.target.closest('#mobile-menu [data-action="open-value-picker"]');
    const closeBtn = e.target.closest('#mobile-menu [data-action="close-value-picker"]');

    const closePicker = (pickerId) => {
      const picker = document.getElementById(pickerId);
      const btn = root.querySelector(
        `[data-action="open-value-picker"][aria-controls="${pickerId}"]`
      );
      if (!picker || !btn) return;

      picker.setAttribute("aria-hidden", "true");
      btn.setAttribute("aria-expanded", "false");
    };

    const openPicker = (pickerId, triggerBtn) => {
      // zavři ostatní otevřené
      root.querySelectorAll('.value-picker[aria-hidden="false"]').forEach((p) => {
        closePicker(p.id);
      });

      const picker = document.getElementById(pickerId);
      const btn =
        triggerBtn ||
        root.querySelector(`[data-action="open-value-picker"][aria-controls="${pickerId}"]`);
      if (!picker || !btn) return;

      // === DESKTOP POPOVER (>= 641px): Localization (Language/Country) vždy nahoru
      if (window.matchMedia("(min-width: 641px)").matches) {
        const isLocalization = !!btn.closest(".mobile-menu__section--localization");

        if (isLocalization) {
          picker.setAttribute("data-picker-position", "top"); // ✅ vždy nahoru
        } else {
          // AUTO pro ostatní pickery
          picker.removeAttribute("data-picker-position"); // default = dolů

          const btnRect = btn.getBoundingClientRect();
          const pickerHeight = picker.offsetHeight || 280;

          const spaceBelow = window.innerHeight - btnRect.bottom;
          const spaceAbove = btnRect.top;

          // když dole není místo, otevři nahoru
          if (spaceBelow < pickerHeight + 12 && spaceAbove > spaceBelow) {
            picker.setAttribute("data-picker-position", "top");
          }
        }
      } else {
        // mobilní drawer režim – směr neřeš
        picker.removeAttribute("data-picker-position");
      }

      picker.setAttribute("aria-hidden", "false");
      btn.setAttribute("aria-expanded", "true");
    };

    // otevření
    if (openBtn) {
      // Capture fáze, aby to nepřebil theme handler v mobile menu
      e.preventDefault();
      e.stopImmediatePropagation();

      const pickerId = openBtn.getAttribute("aria-controls");
      if (!pickerId) return;

      const isExpanded = openBtn.getAttribute("aria-expanded") === "true";
      if (isExpanded) closePicker(pickerId);
      else openPicker(pickerId, openBtn);

      return;
    }

    // zavření tlačítkem X
    if (closeBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();

      const pickerId = closeBtn.getAttribute("aria-controls");
      if (!pickerId) return;

      closePicker(pickerId);
      return;
    }

    // klik mimo picker => zavři
    const anyOpen = root.querySelector('.value-picker[aria-hidden="false"]');
    if (anyOpen) {
      const insidePicker = e.target.closest("#mobile-menu .value-picker-wrapper");
      if (!insidePicker) closePicker(anyOpen.id);
    }
  },
  true // důležité: capture
);

// ESC zavře otevřený picker
document.addEventListener("keydown", (e) => {
  if (e.key !== "Escape") return;
  const root = document.getElementById("mobile-menu");
  if (!root) return;

  const openPicker = root.querySelector('.value-picker[aria-hidden="false"]');
  if (!openPicker) return;

  const btn = root.querySelector(
    `[data-action="open-value-picker"][aria-controls="${openPicker.id}"]`
  );
  openPicker.setAttribute("aria-hidden", "true");
  if (btn) btn.setAttribute("aria-expanded", "false");
});
